import { render, staticRenderFns } from "./SingerInfo.vue?vue&type=template&id=148b62e7&scoped=true&"
import script from "./SingerInfo.vue?vue&type=script&lang=js&"
export * from "./SingerInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingerInfo.vue?vue&type=style&index=0&id=148b62e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b62e7",
  null
  
)

export default component.exports